// Toggle CTA primary button to reflect the action based on type
function primaryCtaText(eventType) {
  return eventType === 'Event' ? 'View Event' : 'Read More'
}

export default primaryCtaText
